import { CSSProperties } from "react";
import styled from "styled-components";

import { Caption } from "@components/Typography";
import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const Container = styled.div`
  border-radius: ${constants.radius.view}px;
  padding: 0px ${spacing.s}px;
`;

export const SubSection = styled.div`
  padding: 0px ${spacing.m}px;
`;

export const ValidatorCaption = styled(Caption)`
  margin-left: ${spacing.xs}px;
  line-height: 0.7em;
`;

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      border: `1px solid ${theme.border}`,
    },
  };

  return styles;
};
